import React from "react";
import CollapsibleSection from "./CollapsibleSection";
import DEALER_SPECIALTIES from "../data/dealerSpecialties";
import SPECIALTY_DESCRIPTIONS from "../data/dealerSpecialtyDescriptions";

const DealerSpecialtiesPanel = ({
  isOpen,
  onToggle,
  formData,
  setFormData,
  customSpecialties,
  setValidationErrors,
  validationErrors,
  specialtyRef,
  updateSpecialty,
  removeSpecialty,
  addSpecialty
}) => {
  return (
    <CollapsibleSection
      title="🛠️ Dealer Type / Specialties"
      isOpen={isOpen}
      onToggle={onToggle}
    >
      <div className="form-section" ref={specialtyRef}>
        <small className="note">
          Select all that apply. Then provide a short description for each selected type below.
        </small>

        {validationErrors.dealerType && (
          <small className="field-error">** Please select at least one specialty or provide a custom one.</small>
        )}

        <div className="checkbox-grid">
          {DEALER_SPECIALTIES.map((type) => (
            <label key={type}>
              <input
                type="checkbox"
                value={type}
                checked={formData.specialties.includes(type)}
                onChange={(e) => {
                  const isChecked = e.target.checked;

                  const updatedSpecialties = isChecked
                    ? [...formData.specialties, type]
                    : formData.specialties.filter((t) => t !== type);

                  const updatedDescriptions = { ...formData.serviceDescriptions };

                  if (isChecked && !updatedDescriptions[type]) {
                    const options = SPECIALTY_DESCRIPTIONS[type] || [];
                    const randomIndex = Math.floor(Math.random() * options.length);
                    updatedDescriptions[type] = options[randomIndex] || "";
                  } else if (!isChecked) {
                    delete updatedDescriptions[type];
                  }

                  setFormData({
                    ...formData,
                    specialties: updatedSpecialties,
                    serviceDescriptions: updatedDescriptions,
                  });

                  const hasBuiltIn = updatedSpecialties.length > 0 && updatedSpecialties.some(
                    key => updatedDescriptions[key]?.trim()
                  );

                  const hasCustom = customSpecialties.some(
                    s => s.title?.trim() && s.description?.trim()
                  );

                  if (hasBuiltIn || hasCustom) {
                    setValidationErrors(prev => ({ ...prev, dealerType: false }));
                  }
                }}
              />
              <span>&nbsp;{type}</span>
            </label>
          ))}
        </div>

        {formData.specialties.map((type) => (
          <div key={type} style={{ marginBottom: "1rem", marginTop: "1rem" }}>
            <label className="descriptionTitle" htmlFor={`desc-${type}`}>
              {type} Description
            </label>
            <textarea
              id={`desc-${type}`}
              rows={2}
              placeholder={`Short description for ${type}`}
              value={formData.serviceDescriptions[type] || ""}
              onChange={(e) => {
                const updatedValue = e.target.value;

                setFormData((prev) => {
                  const newDescriptions = {
                    ...prev.serviceDescriptions,
                    [type]: updatedValue,
                  };

                  const hasBuiltIn = prev.specialties.some(
                    key => newDescriptions[key]?.trim()
                  );

                  const hasCustom = customSpecialties.some(
                    s => s.title?.trim() && s.description?.trim()
                  );

                  if (hasBuiltIn || hasCustom) {
                    setValidationErrors(p => ({ ...p, dealerType: false }));
                  }

                  return {
                    ...prev,
                    serviceDescriptions: newDescriptions,
                  };
                });
              }}
            />
          </div>
        ))}
      </div>

      <div className="form-section">
        <h4 className="section-header-3">🔧 Custom Specialties</h4>
        <small className="note">Add any custom specialties not listed above. Title and short description required.</small>

        {customSpecialties.map((item, idx) => (
          <div className="specialty-entry" key={idx}>
            <input
              type="text"
              maxLength={40}
              placeholder="Add your specialty title here (max 40 char)"
              value={item.title}
              onChange={(e) => updateSpecialty(idx, "title", e.target.value)}
              className="input-title"
            />
            <textarea
              name="specialityDescription"
              maxLength={200}
              placeholder="Briefly describe this specialty here…"
              value={item.description}
              onChange={(e) => updateSpecialty(idx, "description", e.target.value)}
              className="input-description"
              rows={2}
            />
            <span className="description-counter">
              {item.description.length}/200
            </span>
            <button
              type="button"
              className="remove-btn"
              onClick={() => removeSpecialty(idx)}
            >
              ✖ Delete
            </button>
          </div>
        ))}

        <button type="button" className="add-btn" onClick={addSpecialty}>
          + Add Custom Specialty
        </button>
      </div>
    </CollapsibleSection>
  );
};

export default DealerSpecialtiesPanel;